(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  const shippingGrids = new WeakSet();
  function initializeShippingBanners() {
    document.querySelectorAll('.mg-category-shipping').forEach(banner => {
      const grid = banner.parentElement;
      if (!grid || shippingGrids.has(grid)) return;
      shippingGrids.add(grid);
      let pending = false;
      function positionBanner() {
        pending = false;
        if (!grid.isConnected) return;
        const visible = [...grid.querySelectorAll(':scope > .product-grid__item')].filter(card => !card.hidden && !card.classList.contains('mg-filter-excluded') && getComputedStyle(card).display !== 'none');
        const hide = visible.length === 0;
        if (banner.hidden !== hide) banner.hidden = hide;
        if (hide) return;
        const columns = Math.max(1, getComputedStyle(grid).gridTemplateColumns.split(' ').filter(Boolean).length);
        const index = Math.min(columns, visible.length) - 1;
        const anchor = visible[index];
        if (anchor && anchor.nextElementSibling !== banner) anchor.after(banner);
      }
      function scheduleBanner() {
        if (pending) return;
        pending = true;
        requestAnimationFrame(positionBanner);
      }
      new MutationObserver(scheduleBanner).observe(grid, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'hidden'] });
      new ResizeObserver(scheduleBanner).observe(grid);
      scheduleBanner();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeShippingBanners, { once: true });
  else initializeShippingBanners();
  document.addEventListener('shopify:section:load', initializeShippingBanners);

  } catch(e) { console.error(e); }
})();
})();
